import { BrandLogo } from "@/components/BrandLogo";
import { PATH_USER_PROFILE } from "@/constants";
import { cn } from "@/lib/utils";
import { CircleUserIcon } from "lucide-react";
import { memo } from "react";
import { Link } from "react-router-dom";

interface MobileHeaderProps {
  className?: string;
}

export const MobileHeader = memo(({ className }: MobileHeaderProps) => (
  <header
    className={cn("p-2 flex flex-row justify-between items-center", className)}
  >
    <BrandLogo className="h-8" />
    <Link to={PATH_USER_PROFILE}>
      <CircleUserIcon />
    </Link>
  </header>
));
